








import Vue from 'vue';
import { DreamWebDAO, WebDream } from '@/web';
import DreamForm from '@/vue-components/dreams/DreamForm.vue';

const dao = DreamWebDAO.getInstance();

declare interface DreamEditData {
  dream: WebDream;
}

export default Vue.extend({
  name: 'DreamEdit',
  props: {
    id: { type: String },
  },
  components: {
    DreamForm
  },
  data(): DreamEditData {
    return {
      dream: new WebDream('',''),
    };
  },
  computed: {
    title(): string {
      return 'Sparkello - Edit Dream';
    },
  },
  created() {
    //On create check that the state store is populated, and if not then retrieve the individual dream record

    //Check the dream is in the store
    const storeDream = this.$store?.state?.myDreams?.index?.get(this.id);
    if (storeDream) {
      this.dream = storeDream.clone() as WebDream;
    }

    //If the dream is not in the store index retrieve the data remotely and set it
    // in the dream data property
    if (!this.dream?.id) {
      dao.getDream(this.id).then((value: WebDream | undefined) => {
        if (value) {
          this.dream = value.clone() as WebDream;
        }
      }).catch((error) => {
        console.error(error);
      });
    }
  },
  methods: {
    saveDream() {
      console.log('Save dream', this.dream);
      if (this.dream) {
        dao.setDream(this.dream);
        this.$router.push('/dreams');
      }
    },
    cancel() {
      this.$router.push('/dreams/'+this.id);
    },
  },
});
